import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import { QueryClientProvider } from '@tanstack/react-query';
import './assets/fonts/fonts.css';
import { queryClient } from './api/query-client';
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { NotificationsProvider } from '@toolpad/core';
import { AuthContextProvider, LoaderContextProvider, RedirectsProvider } from './assets/context-providers';
import { GlobalStyles } from '@mui/styled-engine';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <LoaderContextProvider>
        <NotificationsProvider>
          <AuthContextProvider>
            <RedirectsProvider>
              <CssBaseline />
              <App />
              <GlobalStyles styles={{
                'html, body': {
                  backgroundColor: '#F5F5F5',
                },
              }} />
            </RedirectsProvider>
          </AuthContextProvider>
        </NotificationsProvider>
      </LoaderContextProvider>
    </ThemeProvider>
  </QueryClientProvider>,
);
